<div class="col-12">
    <mat-form-field>
        <mat-select [(value)]="selected" placeholder="Borrador Formularios">

            <mat-optgroup label="Mis Formulario">
                <mat-option [value]="{id:borrador.draftId._id, title: borrador.draftId.name}" *ngFor="let borrador of borradores; let i = index">
                    {{borrador.draftId.name}}
                </mat-option>
            </mat-optgroup>

        </mat-select>

    </mat-form-field>
</div>

<div class="btn-group">
    <button mat-raised-button color="primary" class="spacer" [disabled]="!selected" (click)="loadDraft(selected)">Cargar Borrador</button>
    <button mat-raised-button color="warn" class="spacer" [disabled]="!selected" (click)="deleteDraft(selected)">Eliminar Borrador</button>
</div>